<template>
  <div class="YyjZsxxData">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="width: calc(100% - 225px)"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-row>
            <el-col :span="7">
              <el-form-item label="预警类型:">
                <el-select v-model="formInline.yjlxList" filterable multiple placeholder="请选择(可多选)" style="width: 100%">
                  <el-option
                    v-for="item in yjlxSelects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="证书类型:">
                <el-select v-model="formInline.sjlx" filterable placeholder="请选择">
                  <el-option
                    v-for="item in sjlxSelects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预警日期:">
                <el-col :span="10">
                  <el-date-picker
                    v-model="formInline.beginTime"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  />
                </el-col>
                <el-col style="text-align: center" class="line" :span="3">-</el-col>
                <el-col :span="10">
                  <el-date-picker
                    v-model="formInline.endTime"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width:225px">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            size="small"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            icon="el-icon-refresh-left"
            round
            size="small"
            @click="resetDataSource"
          >重置</el-button>
        </div>

      </div>
    </div>
    <div
      style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;"
    >
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            icon="el-icon-upload2"
            size="mini"
            @click="dcexcel"
          >导出</el-button>
        </div>
        <el-table
          ref="xqkczlTabel"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            width="80px"
            prop="sjlxLabel"
            label="证件类型"
          />
          <el-table-column
            width="180px"
            prop="xkzBh"
            label="许可证编号"
          />
          <el-table-column
            min-width="160px"
            prop="hxpMc"
            label="化学品"
          />
          <el-table-column
            min-width="160px"
            label="许可证数量"
          >
            <template slot-scope="scope">
              {{ scope.row["hzsl"] +
                "  (" +
                scope.row["hzslDw"] +
                ")" }}
            </template>
          </el-table-column>
          <el-table-column
            width="100px"
            prop="hfrqStr"
            label="核发日期"
          />
          <el-table-column
            width="220px"
            prop="yxqx"
            label="有效期限"
          />
          <el-table-column
            min-width="180px"
            prop="sqdwMc"
            label="申请单位"
          />
          <el-table-column
            width="80px"
            prop="ztMc"
            label="状态"
          />
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getYjczXgzjxx, exportYjczXgzjxx } from '@/assets/js/system'
export default {
  name: 'YyjZsxxData',
  data() {
    return {
      formInline: { // 搜索表单
        yjlxList: [],
        sjlx: '',
        beginTime:'',
        endTime:'',
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
      yjlxSelects: [
        {
          value: '1',
          label: '证书出入库不符'
        },
        {
          value: '2',
          label: '证书超期未报备(核销)'
        },
        {
          value: '3',
          label: '证书连续使用率低'
        },
        {
          value: '4',
          label: '证书连续未使用'
        },
        {
          value: '5',
          label: '跨市运输选了同市'
        },
      ],
      sjlxSelects: [
        {
          value: '1',
          label: '购买证'
        },
        {
          value: '2',
          label: '运输证'
        },
      ],
    }
  },
  mounted() {
    this.loadDatasource()
  },
  methods: {
    dcexcel() {
      this.$message.info('正在导出中...')
      exportYjczXgzjxx({
        param: this.formInline
      }).then((e) => {
        this.$message.success('导出成功!')
        const table = '预警相关证书信息'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      getYjczXgzjxx({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        province: '',
        hxpBms: []
      },
      this.loadDatasource()
    }
  }
}
</script>

<style scoped lang='less'>
  .YyjZsxxData {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
